import InvestorLoginForm from './InvestorLoginForm';

export default InvestorLoginForm;
